(() => {
  function initExpandableContent(wrapper) {
    if (!wrapper) return;

    const content = wrapper.querySelector('[data-expandable-content]');
    const toggle = wrapper.querySelector('[data-expandable-toggle]');

    if (!content || !toggle) return;

    const collapsedHeight = Number(wrapper.dataset.expandableMaxHeight || 275);
    const forceToggle = wrapper.dataset.expandableForceToggle === 'true';

    toggle.hidden = true;
    content.classList.remove('is-collapsed', 'is-expanded');
    wrapper.classList.remove('is-collapsed');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = toggle.dataset.expandText || 'See more';

    if (!forceToggle && content.scrollHeight <= collapsedHeight) return;

    content.style.setProperty('--expandable-content-max-height', `${collapsedHeight}px`);
    wrapper.classList.add('is-collapsed');
    content.classList.add('is-collapsed');
    toggle.hidden = false;

    if (wrapper.dataset.expandableContentInitialized === 'true') return;

    wrapper.dataset.expandableContentInitialized = 'true';

    toggle.addEventListener('click', () => {
      const isExpanded = content.classList.toggle('is-expanded');
      const expandText = toggle.dataset.expandText || 'See more';
      const collapseText = toggle.dataset.collapseText || 'See less';

      content.classList.toggle('is-collapsed', !isExpanded);
      wrapper.classList.toggle('is-collapsed', !isExpanded);

      toggle.textContent = isExpanded ? collapseText : expandText;
      toggle.setAttribute('aria-expanded', String(isExpanded));

      if (!isExpanded) {
        wrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }

  function initExpandableContentBlocks(container = document) {
    container.querySelectorAll('[data-expandable-content-wrap]').forEach(initExpandableContent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initExpandableContentBlocks();
    });
  } else {
    initExpandableContentBlocks();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initExpandableContentBlocks(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    initExpandableContentBlocks(event.target);
  });
})();
